<div class="col-md-12 grid-margin stretch-card">
  <div class="card">
    <div class="card-body">
      <h4 class="card-title mt-3">User Manual for {{RoleName}} </h4>
      <div class="col-md-11" style="text-align:right;">
        <a [href]="DocURL" title="Download" download><i class="fa fa-download"></i></a>
      </div>
      <div class="col-md-12">
        <pdf-viewer [src]="DocURL" [rotation]="0" [original-size]="false" [show-all]="true" [fit-to-page]="false"
          [zoom]="1" [zoom-scale]="'page-width'" [stick-to-page]="false" [render-text]="true"
          [external-link-target]="'blank'" [autoresize]="true" [show-borders]="false"
          style="width: 100%; height: 600px;"></pdf-viewer>
      </div>
    </div>
  </div>
</div>